import { Search } from '@sainsburys-tech/luna-icons'
import SitesApi from '../../api/sitesApi'
import FormAlerts from "../Common/FormAlerts";
import { Pagination } from '@sainsburys-tech/luna-pagination';
import { AutocompleteField } from "@sainsburys-tech/luna-react";
import WorkordersList from '../Common/WorkordersList'
import { useApiClient } from '../../context/AppContext'
import React, { useRef, useState, useEffect } from 'react'
import riskWorkordersApi from '../../api/riskWorkordersApi'
import { FilledButton, OutlinedButton, TextInputField, TextInput } from '@sainsburys-tech/luna-react'
import { Workorders, RiskWorkorderFilter, RiskWorkorderModel, statusCount,  } from '../../types/Entities/Workorders'
import { GridWrapper, GridItem, SearchInput, CheckboxField, FormGroup,  SelectField, Card, List , ListItem, Alert, Container} from '@sainsburys-tech/luna-react'
import { debug } from 'util';

import Tiles from '../Common/TilesInfo'


const RiskWorkorders = (props: { status : Boolean }) => {
  const recordsPerPage = 20;
  const apiClient = useApiClient()
  const [sortBy , setSortBy] =useState('')
  const [loader, setLoader] = useState(false)
  const [siteOptions, setSiteOptions] = useState([{}])
  const [contractorOptions, setContractorOptions] = useState([{}])
  const [currentPage, setCurrentPage] = React.useState(1)
  const [totalRecords, setTotalRecords] = useState<number>()
  const [workorderStatusCount, setWorkorderStatusCount] = useState<statusCount>()
  const [errorAlert, setErrorAlert] = useState<false | string>(false)
  const [successAlert, setSuccessAlert] = useState<false | string>(false)
  const [riskWorkorders, setRiskWorkorders] = useState([] as Workorders[]);
  const [workorderStatus, setWorkorderStatus] = useState([] as Array<Array<string | Boolean>>)
  const defaultFalseStatus = [["Open", false], ["In Progress", false], ["Closed", false]]
  const defaultTrueStatus = [["Open", true], ["In Progress", true], ["Closed", false]]
  const sortByOptions = [
    { value: 'Risk Score Ascending', label: 'Risk Score Ascending' },
    { value: 'Risk Score Descending', label: 'Risk Score Descending' },
    { value: 'dateAscending', label: ' Latest modified date' },
    { value: 'dateDescending', label: 'Oldest modified date' },
  ]
  
  const handleScrollModal = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    })
  }
  
  const defaultFilter ={
    SearchByAssignedContractor: "",
    SearchByWorkOrderNumber: "",
    SearchBySiteName: "",
    SearchByStatus: ["Open", "In Progress"],
    SortColumn: "risk_score",
    SortColumnDirection: "desc",
    StartIndex: 1,
    PageSize: recordsPerPage,
    lastUpdatedByMe: false
  }
  const [filter, setFilter] = useState({} as RiskWorkorderFilter)
  const [duplicateFilter, setDuplicateFilter] = useState({} as RiskWorkorderFilter)
  const scrollToTop = () => document.querySelector('div.ln-o-container.content')?.scrollTo(0, 0)

  const getFilterFromLocalStorage = (filterData: string) => {
    return filterData ? JSON.parse(filterData) : null;
  };
  
  const filterRef = useRef<RiskWorkorderFilter>({});

  const setAndStoreFilter = (newFilter: RiskWorkorderFilter) => {
    setDuplicateFilter(newFilter);
    filterRef.current = newFilter;
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(() => {
      fetchDataFor_N_Seconds()
    }, 300000);
    return () => clearInterval(interval);
    }, []);
    

  const fetchDataFor_N_Seconds = async () => {
    let filterdDataObject: RiskWorkorderFilter | undefined;
    try {
      const filterData = localStorage.getItem('riskWorkorderFilter') as string;
      filterdDataObject=getFilterFromLocalStorage(filterData)
    } catch (error) {
      console.error("Error accessing localStorage:", error);
    }
    if (!filterdDataObject) {
      filterdDataObject = filterRef.current;
    }
    if( filterdDataObject){
      if (filterdDataObject.StartIndex !== undefined) {
      setCurrentPage(filterdDataObject.StartIndex);
      }
      if (Array.isArray(filterdDataObject.SearchByStatus)) {
        for (let i = 0; i < filterdDataObject.SearchByStatus.length; i++) {
          const index = defaultFalseStatus.findIndex(
          item => item[0] === filterdDataObject!.SearchByStatus![i]
          );
          if (index !== -1) {
            defaultFalseStatus[index][1] = true;
          }
        }
        setWorkorderStatus(defaultFalseStatus);
      }
      setWorkorderStatus(defaultFalseStatus)
      if(filterdDataObject.SortColumn === 'risk_score'){
        setSortBy(filterdDataObject.SortColumnDirection === 'asc' ? 'Risk Score Ascending' : 'Risk Score Descending')
      }else{
        setSortBy(filterdDataObject.SortColumnDirection === 'desc' ? 'dateAscending' : 'dateDescending')
      }
      setFilter(filterdDataObject)
      await loadriskwo(filterdDataObject)
    }else{
      setWorkorderStatus(defaultTrueStatus)
      setFilter(defaultFilter)
      await loadriskwo(defaultFilter)
      localStorage.setItem('riskWorkorderFilter' , JSON.stringify(defaultFilter))
    }
  }

  const fetchData = async () => {
    const filterData = localStorage.getItem('riskWorkorderFilter') as string;
    const filterdDataObject=getFilterFromLocalStorage(filterData)
    // const filterdDataObject=filterRef.current
    if(!props.status && filterdDataObject){
        setCurrentPage(filterdDataObject.StartIndex)
        for(var i=0 ; i<filterdDataObject.SearchByStatus.length;i++){
          const index = defaultFalseStatus.findIndex(item => item[0] === filterdDataObject.SearchByStatus[i]);
            defaultFalseStatus[index][1]=true
        }
        setWorkorderStatus(defaultFalseStatus)
        if(filterdDataObject.SortColumn === 'risk_score'){
          setSortBy(filterdDataObject.SortColumnDirection === 'asc' ? 'Risk Score Ascending' : 'Risk Score Descending')
        }else{
          setSortBy(filterdDataObject.SortColumnDirection === 'desc' ? 'dateAscending' : 'dateDescending')
        }
        setFilter(filterdDataObject)
        setAndStoreFilter(filterdDataObject)
        await loadriskwo(filterdDataObject);
      }else{
        setWorkorderStatus(defaultTrueStatus)
        setFilter(defaultFilter)
        setAndStoreFilter(defaultFilter)
        localStorage.setItem('riskWorkorderFilter' , JSON.stringify(defaultFilter))
        await loadriskwo(defaultFilter)
      }
      await getsitesApi();
      await getProviderCollection();
  }

  const getsitesApi = async () => {
    return SitesApi.getallSiteNames(apiClient)
    .then((response) => {
      setSiteOptions(response)
    })
      .catch(error => setErrorAlert('Something went wrong!'))
  }
  const getProviderCollection = async () => {
    return riskWorkordersApi.getallAssignedContractors(apiClient)
    .then((response) => {
      setContractorOptions(response.map((x) => ({
        label : x.label,
        value : x.label
      })))
    })
      .catch(error => setErrorAlert('Something went wrong!'))
  }
  
  const loadriskwo = async (filters: RiskWorkorderFilter) => {
    setLoader(true)
    await loadallriskworkorderspaging(filters)
    setLoader(false)
    scrollToTop()
  }
  
  const serachFilter= async () => {
    const filterforSearch={...filter}
    filterforSearch.StartIndex=1
    setFilter(filterforSearch)
    setAndStoreFilter(filterforSearch)
    setCurrentPage(1)
    loadriskwo(filterforSearch)
    localStorage.setItem('riskWorkorderFilter' , JSON.stringify(filterforSearch))
  }

  const clearAlerts = () => {
    setErrorAlert(false);
    // setSuccessAlert(false);
  }

  const loadallriskworkorderspaging = async (filters: RiskWorkorderFilter): Promise<RiskWorkorderModel> => {
    return riskWorkordersApi
      .getallriskworkorderspaging(apiClient, filters)
      .then((response) => {
        setRiskWorkorders(response.riskWorkOrders)
        setTotalRecords(response.recordsCount)
        setWorkorderStatusCount(response.statusCounts)
        if (!response) {
          throw new Error('Invalid response.')
        }
      }).catch(error => {
        setErrorAlert('Something went wrong!')
        return error
      })
  } 

  const SearchRiskworkOrders = (workorderNumber: any) => {
    const regex = /^[0-9]+$/;
    const newValue = workorderNumber;
    if(regex.test(newValue) || newValue===""){
    setFilter((prevFilter: RiskWorkorderFilter) => ({
      ...prevFilter,
      SearchByWorkOrderNumber: newValue,
    }))
  }
  }

  const CheckCheckBox = (props: any) => {
    let searchByStatusValue = filter.SearchByStatus;
    const index = workorderStatus.findIndex(item => item[0] === props.target.defaultValue);
    
    if (props.target.checked) {
      if (!searchByStatusValue?.includes(props.target.defaultValue)) {
        searchByStatusValue?.push(props.target.defaultValue);
        let workOrderStatusFilter = [...workorderStatus]
        workOrderStatusFilter[index]=[props.target.defaultValue , 'true']
        setWorkorderStatus(workOrderStatusFilter)
      }
    } else {
      searchByStatusValue = searchByStatusValue?.filter((status: any) => status !== props.target.defaultValue);
      let workOrderStatusFilter = [...workorderStatus]
      workOrderStatusFilter[index]=[props.target.defaultValue , 'false']
      setWorkorderStatus(workOrderStatusFilter)
    }
    setFilter((prevFilter: RiskWorkorderFilter) => ({
      ...prevFilter,
      SearchByStatus: searchByStatusValue
    }));
  }

  const selectedSite = (props: any) => {
    if(props === null){
      setFilter((prevFilter: RiskWorkorderFilter) => ({
        ...prevFilter,
        SearchBySiteName: ''
      }));
    }else{
      if(props && props.value){
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SearchBySiteName: props.value
        }));
      }else{
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SearchBySiteName: props.target.value
        }));
      }
    }
  }
  const selectedContractor = (props: any) => {
    if(props === null){
      setFilter((prevFilter: RiskWorkorderFilter) => ({
        ...prevFilter,
        SearchByAssignedContractor: ''
      }));
    }else{
      if(props && props.value){
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SearchByAssignedContractor: props.value
        }));
      }else{
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SearchByAssignedContractor: props.target.value
        }));
      }
    }
  }

  const selectSortBy = (props: any) => {
    switch (props.target.value) {
      case 'Risk Score Ascending':
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SortColumn: 'risk_score',
          SortColumnDirection: 'asc'
        }));
        setSortBy('Risk Score Ascending')
        break;
      case 'Risk Score Descending':
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SortColumn: 'risk_score',
          SortColumnDirection: 'desc'
        }));
        setSortBy( 'Risk Score Descending')
        break;
      case "dateAscending":
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SortColumn: 'datemodified',
          SortColumnDirection: 'desc'
        }));
        setSortBy('dateAscending')
        break;
      case "dateDescending":
        setFilter((prevFilter: RiskWorkorderFilter) => ({
          ...prevFilter,
          SortColumn: 'datemodified',
          SortColumnDirection: 'asc'
        }));
        setSortBy('dateDescending')
        break;
      default :
        setSortBy('')
        break;
    }
  }

  const discardFilters = async () => {
    setWorkorderStatus(defaultTrueStatus)
    setCurrentPage(1)
    setFilter(defaultFilter)
    setAndStoreFilter(defaultFilter)
    localStorage.setItem('riskWorkorderFilter' , JSON.stringify(defaultFilter))
    window.location.reload()
    scrollToTop()
  }

  const isMobile = () => {
    if (window.innerWidth > 1200) {
      return false;
    }
    return true;
  };

const lastUpdatedByMe = (props : any) => {
    setFilter((prevFilter) => ({
      ...prevFilter,
      lastUpdatedByMe : props.target.checked
    }))
}

  return (
    <>
      <FormAlerts
        showError={errorAlert}
        showSuccess={successAlert}
        onClose={clearAlerts}
      />
      <GridWrapper>
        <GridItem size={{ xs: "1/1", lg: "1/4" }} >
          <div style={{display:'contents'}}
            className={ "cb-c-alerts-page__filter-container--full-screen"}>
            <GridItem
              size={{ xs: "1/1", sm: "1/1" }}
              className="cb-c-alerts-page__left-panel alerts-page__filter">
              <div className="cb-c-alerts-page__options">
                <div>
                  <h4>Filter Workorder</h4>
                  <FormGroup name="workordernumber" label="Workorder Number">
                    <SearchInput
                      name="workorder-search"
                      value={filter.SearchByWorkOrderNumber}
                      placeholder="e.g. 56870001"
                      onChange={(e: any) => SearchRiskworkOrders(e.target.value)}
                      hasAction
                      action={
                        <button onClick={() => serachFilter()}>
                          <Search />
                        </button>
                      }
                    /></FormGroup>
                  <div>
                    <GridWrapper>
                      {/* <GridItem size="1/1">
                        <h3>Filter Workorders</h3>
                      </GridItem> */}
                      <GridItem >
                        {" "}
                          <ul key={filter.lastUpdatedByMe ? 1 : 2}>
                            <CheckboxField
                              name={"Last Updated by Me"}
                              label="Field label"
                              hideLabel
                              placeholder="Placeholder"
                              onChange={lastUpdatedByMe}
                              options={[
                                {
                                  value: "Last Updated by Me",
                                  label: "Last Updated by Me",
                                  defaultChecked: filter.lastUpdatedByMe
                                }
                              ]}
                            />
                          </ul>
                      </GridItem>
                    </GridWrapper>
                  </div>
                  <FormGroup name="workordernumber" label="Risk Status">
                    <GridWrapper name='Workorder' label='workorder'>
                  {workorderStatus && 
                  workorderStatus.map((status , index) => (
                    <>
                      <GridItem size='4/5'>
                        {" "}
                          <ul key={index}>
                            <CheckboxField
                              name={status[0]}
                              checked={status[1]}
                              label="Field label"
                              hideLabel
                              placeholder="Placeholder"
                              onChange={CheckCheckBox}
                              options={[
                                {
                                  value: status[0],
                                  label: status[0],
                                  defaultChecked: status[1]
                                }
                              ]}
                            />
                          </ul>
                      </GridItem>
                      <GridItem
                        size="1/5"
                        className="cb-c-alert-filter__is-active"
                        >
                          {workorderStatusCount && (
                            <div className="ln-c-form-group">
                              <div className="ln-c-form-option">
                                { index== 0 ? ''
                                  : index == 1 ? workorderStatusCount.InProgress ? workorderStatusCount.InProgress : '0' 
                                                : workorderStatusCount.Closed ? workorderStatusCount.Closed : '0'
                                }
                              </div>
                            </div>
                          )}
                      </GridItem>
                      </>
              ))}
                      <GridItem>
                        <AutocompleteField
                          value={filter.SearchByAssignedContractor}
                          label={'Assigned Contractor'}
                          defaultSelectedOption={filter.SearchByAssignedContractor}
                          placeholder="Please select a Contractor"
                          name={"SiteSelector"}
                          onSelect={(selectedContractorOption: any) => selectedContractor(selectedContractorOption)}
                          onChange={ selectedContractor}
                          options={contractorOptions}
                          noResultsMessage="No assigned contractors found"
                          /> 
                        <AutocompleteField
                          value={filter.SearchBySiteName}
                          label={'Site'}
                          defaultSelectedOption={filter.SearchBySiteName}
                          placeholder="Please select a site"
                          name={"SiteSelector"}
                          onSelect={(selectedSiteOption: any) => selectedSite(selectedSiteOption)}
                          onChange={ selectedSite}
                          options={siteOptions}
                          noResultsMessage="No sites found"
                          /> 
                        <SelectField
                          value={sortBy}
                          name={"StoreSelector"}
                          label="Sort By"
                          options={sortByOptions}
                          // defaultSelectedOption={"select"}
                          // placeholder={'select sort by'}
                          onSelect={selectSortBy}
                          onChange={selectSortBy}
                          noResultsMessage="No stores found"
                        />
                      </GridItem>
                    </GridWrapper>
                  </FormGroup>
                  <>
                    <GridItem size={{ xl: '1', ss: '1', default: '1/1' }} className='formInputMaxWidth'>
                      <div className='formButtonGroup'>
                        <OutlinedButton size='200px' onScroll={handleScrollModal} onClick={discardFilters} className='formDiscardButton' >Discard</OutlinedButton>
                        <FilledButton size='200px' onScroll={handleScrollModal} onClick={serachFilter} className='formSaveButton' >Search</FilledButton>
                      </div>
                    </GridItem>
                  </>

                </div>
              </div>
            </GridItem>
            <br/><br/>
          </div>
        </GridItem> 
        <GridItem 
          className={"cb-c-alerts-page__right-panel"}
          size={{ xs: "1/1", lg: "3/4" }}>
            <div>
            <GridWrapper>
                  <Tiles />
              </GridWrapper> 
            </div> 
            {/* <div> */}
            <br/>
          {!loader && (
            riskWorkorders.length > 0 ? riskWorkorders.map((workorder, index) => (
              <div key={workorder.id}>
                <WorkordersList workorder={workorder} />
              </div>
            )) : <div>There is no data to display</div>)}
          {
            (loader === true) && (<div className='loader'></div>)
          }
          {riskWorkorders.length > 0 && !loader &&
            <Pagination
              showFirstAndLast
              showPages
              current={currentPage}
              total={totalRecords ? Math.ceil(totalRecords / recordsPerPage) : 1}
              onChange={(page: number, e: React.MouseEvent<HTMLButtonElement>) => {
                setCurrentPage(page);
                const filterforPage={...filter}
                filterforPage.StartIndex=page
                localStorage.setItem('riskWorkorderFilter' , JSON.stringify(filterforPage))
                setFilter((prevFilter: RiskWorkorderFilter) => ({
                  ...prevFilter,
                  StartIndex: page
                }));
                loadriskwo(filterforPage)
              }}
            />
          }
          {/* </div> */}
        </GridItem>
      </GridWrapper>
    </>
  )
}

export default RiskWorkorders
